import request from '@/utils/request';
import Resource from '@/api/resource';

class ConfigResource extends Resource {
  constructor() {
    super('config');
  }

  // 获取广告配置列表接口 */
  getConfigListApi(data) {
    return request({
      url: `${this.uri}`,
      method: 'GET',
      params: data,
    });
  }

  // 保存广告接口
  setConfigApi(data) {
    return request({
      url: `${this.uri}`,
      method: 'POST',
      data,
    });
  }

  // 获取广告配置接口
  getConfigDataApi(data) {
    return request({
      url: `${this.uri}/getConfig`,
      method: 'GET',
      params: data,
    });
  }
}

export { ConfigResource as default };
